<template>
  <RydHeader :title="t('cars.page.title')" 
             backBtnVisible 
             :backButtonName="t('a11y.cta_back_to_profile')"
             @backButtonClick="redirectToApp()"
  />
  <RydLoadingOverlay v-if="!componentReady" />
  <!-- Car list -->
  <div v-else class="view-block pt-6 px-4">
    <section>
      <h2 class="fs-20 text-left mb-1 font-bold">
        {{ t('cars.title') }}
      </h2>
      <p class="fs-16">
        {{ t('cars.subtitle') }}
      </p>
      <ul class="pt-4 m-0">
        <li v-for="car in sortedCars" :key="car.thingId">
          <div class="list-none h-9 flex justify-center flex-col my-3">
            <router-link :to="`/cars/${car.thingId}`" class="flex justify-between items-center w-full">
              <div>
                <span class="fs-15 font-medium"> {{ car.nickName }}</span>
                <p
                  v-if="car.ymme?.licensePlate"
                  class="text-fs-12 pr-4"
                >
                  {{ t('cars.list.license_plate') }}: {{ car.ymme?.licensePlate }}
                </p>
              </div>
              <div class="flex items-center">
                <div v-if="activeCarId === car.thingId" 
                     class="bg-ryd-primary rounded-xl text-white px-4 py-0.5 mr-2 font-medium fs-15"
                >
                  {{ t('cars.list.status') }}
                </div>
                <RydIcon icon="chevron-right" />
              </div>
            </router-link>
          </div>
          <RydDivider class="mt-1 w-full" />
        </li>
      </ul>
    </section>

    <RydButton class="w-full my-6" href="/cars/new" :name="t('cars.button.action1')">
      {{ t('cars.button.action1') }}
    </RydButton>
    <div v-if="errorAPI" class="mt-6 mb-8">
      {{ t('errors.car.get_cars') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import RydButton from '@/components/RydButton/RydButton.vue';
import RydIcon from '@/components/RydIcon/RydIcon.vue';
import RydLoadingOverlay from '@/components/RydLoading/RydLoadingOverlay.vue';
import RydDivider from '@/components/RydDivider.vue';
import RydHeader from '@/components/RydHeader/RydHeader.vue';


import { useAuthStore } from '@/store/auth/auth';
import { computed, onMounted, ref } from 'vue';


const authState = useAuthStore();

const errorAPI = ref(false);

const componentReady = computed(() => !authState.isLoading);
onMounted(() => {
  history.replaceState({}, '', window.location.href);
});
// sort all cars by nickName
const sortByNickname = computed(() => {
  // shallow copy for avoiding side effect inside a computed
  const sortByNickname = [...authState.userPreferences];

  sortByNickname.sort((a, b) => a.nickName.localeCompare(b.nickName));
  return sortByNickname;
});
const sortedCars = computed(() => {
  const preferredCar = sortByNickname.value.find((car) => car.thingId === activeCarId.value);
  if (preferredCar) {
    return [preferredCar, ...sortByNickname.value.filter((car) => car.thingId !== activeCarId.value)];
  }
  return sortByNickname.value;
});
const activeCarId = computed(() => authState.preferredVehicle?.thingId);

const redirectToApp = () => {
  const urlCallbackObject = new URL('webViewEvent://profileCarsBack');
  window.location.replace(urlCallbackObject.toString());
};

</script>
